import { Component, Input, OnInit } from '@angular/core';
import { TextService } from 'src/app/core/service/text.service';
import { updateWorkflow } from 'src/app/root-store/workflow/workflow.actions';
import { MessageService } from 'primeng/api';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-approve-reject',
  templateUrl: './approve-reject.component.html',
  styleUrls: ['./approve-reject.component.scss'],
})
export class ApproveRejectComponent implements OnInit {
  @Input() title = '';
  @Input() workFlowActivity;
  @Input() workFlowStates;
  @Input() data;
  submitted = false;
  generalTexts: any = {
    txtComment: { labelId: 'L_COMMENT' },
    txtSelect: { labelId: 'PH_SELECT' },
    btnExportDoc: { labelId: 'L_EXPORT_DOC' },
    btnExportPdf: { labelId: 'L_EXPORT_PDF' },
    btnSubmitReview: { labelId: 'L_SUBMIT_REVIEW' },
    btnSubmit: { labelId: 'L_SUBMIT' },
    title: { labelId: 'L_BCP_SUMMARY' },
    btnCancel: { labelId: 'L_CANCEL' },
    approveBtn: { labelId: 'L_APPROVE' },
    rejectBtn: { labelId: 'L_REJECT' },
    approveRecord: { labelId: 'L_APPROVED'},
    rejectSuccessMsg: { labelId: 'L_REJECTED' },
    approveErrorMsg: { labelId: 'L_ERROR_TITLE' }
  };
  approve: boolean;
  comment = '';
  commentDialogVisible: boolean;

  constructor(
    private messageService: MessageService,
    private route: Router,
    private store: Store,
    private textService: TextService
  ) {}

  ngOnInit(): void {
    this.textService
      .convert(this.generalTexts)
      .subscribe((texts) => (this.generalTexts = texts));
  }

  async saveWorkflowActivity() {
    this.submitted = true;
    if (this.approve) {
      this.workFlowStates = this.workFlowStates.find(
        (state) => state.stateId === 'S_APPROVED'
      );
    } else {
      this.workFlowStates = this.workFlowStates.find(
        (state) => state.stateId === 'S_REJECTED'
      );
    }

    this.store.dispatch(
      updateWorkflow({
        workflowActivity: {
          ...this.workFlowActivity,
          comment: this.comment,
          workFlowStates: this.workFlowStates,
        },
           close: this.data?.success,
        msg: {
          success:
            this.workFlowStates?.stateId === 'S_APPROVED'
              ? this.generalTexts.approveRecord.label
              : this.generalTexts.rejectSuccessMsg.label,
          error: this.generalTexts.approveErrorMsg.label,
        },
      })
    );

    try {
      await this.store.toPromise(); // Wait for the dispatch to complete
      this.submitted = false;
    } catch (error) {
      // Handle any errors that occurred during the dispatch
      console.error(error);
    }
  }

  toggleCommentDialog(flag = false) {
    this.commentDialogVisible = !this.commentDialogVisible;
    this.approve = flag;
  }
}
